import { useMemo } from 'react';

import type { Account } from '@shared/products-types';
import { isLoanAccount } from '@shared/products-core';

import { useProducts } from './useProducts';

type HookReturnType = ReturnType<typeof useProducts<Account>>;

export const useLoanAccounts: () => HookReturnType = () => {
    const { isPending, error, refetch, products = [] } = useProducts();

    const [loanAccounts, loanAccountsById] = useMemo(() => {
        const filteredLoanAccounts = products.filter(isLoanAccount);
        return [
            filteredLoanAccounts,
            filteredLoanAccounts.reduce(
                (acc, current) => {
                    acc[current.id] = current;
                    return acc;
                },
                {} as HookReturnType['productsById'],
            ),
        ];
    }, [products]);

    return {
        isPending,
        error,
        refetch,
        products: loanAccounts,
        productsById: loanAccountsById,
    };
};
